<template>
    <section class="friend_tab_content flex">

        <div class="title_notice_line">
            <div class="coeffs_heading container">
                <h1 class="page-title title is-size-2 has-text-weight-bold">{{ $t('modules.refs.formStep4.title') }}</h1>
                <notifText v-html="$t('modules.refs.formStep4.globalNotice')" />
            </div>
        </div>


        <div class="columns">
            <div class="column">
                <div class="scores_columns_container">
                    <div v-for="( scoreKey, index ) in firstScoresMap">
                        <h3 class="dim_cat_title ref_score_cat_title" v-if="index == 0">
                            {{ $t('dimensions.skills_titles.title1') }}
                        </h3>
                        <h3 class="dim_cat_title ref_score_cat_title" v-if="index == 2">
                            {{ $t('dimensions.skills_titles.title3') }}
                        </h3>

                        <SkillScoreRadios
                            :score-id="scoreKey"
                            :score='friendRef.sight3_scores[scoreKey]'
                            :ref-score="baseRef.sight3_scores[scoreKey]"

                            @change="syncVal" />
                    </div>
                </div>

            </div>
            <div class="column">
                <div class="scores_columns_container">

                    <div v-for="( scoreKey, index ) in middleScoresMap">
                        <h3 class="dim_cat_title ref_score_cat_title" v-if="index == 0">
                            {{ $t('dimensions.skills_titles.title4') }}
                        </h3>


                        <SkillScoreRadios
                            :score-id="scoreKey"
                            :score='friendRef.sight3_scores[scoreKey]'
                            :ref-score="baseRef.sight3_scores[scoreKey]"

                            @change="syncVal" />
                    </div>
                </div>

            </div>
            <div class="column">
                <div class="scores_columns_container">
                    <div v-for="( scoreKey, index ) in lastScoresMap">

                        <h3 class="dim_cat_title ref_score_cat_title" v-if="index == 0">
                            {{ $t('dimensions.skills_titles.title2') }}
                        </h3>


                        <SkillScoreRadios
                            :score-id="scoreKey"
                            :score='friendRef.sight3_scores[scoreKey]'
                            :ref-score="baseRef.sight3_scores[scoreKey]"

                            @change="syncVal" />
                    </div>
                </div>

            </div>
        </div>


    </section>
</template>

<script>

export default {
    name: 'FriendScores',
    components: {

    },
    data(){
        return {
            firstScoresMap: ["r1", "r2", "r8", "r9"],
            middleScoresMap: ["r10", "r11", "r12", "r13", "r14", "r15", "r16", "r17"],
            lastScoresMap: ["r3", "r4", "r5", "r6", "r7"],
        }
    },
    computed: {
        friendRef(){
            return this.$store.state.FriendStore.friendRef
        },
        baseRef(){
            return this.friendRef.sight_ref
        },
        associatedRef(){
            return this.friendRef.sight_ref.associated_ref
        },
        isAligned(){
            return JSON.stringify(this.friendRef.sight3_scores) ===  JSON.stringify(this.associatedRef.sight3_scores)
        },
    },
    beforeCreate(){

    },
    methods: {
        syncVal(scoreData){
            const objectToSend = {sight3_scores: { } }
            objectToSend.sight3_scores[scoreData.id] = scoreData.val
            this.$store.commit('FriendStore/updateFriendRefData', objectToSend )
        }
    }
}

</script>

<style lang="scss">
.friend_tab_content{
    .friends_heading.scores_heading{
        margin-bottom: 60px;
        .notification_text{
            // background-color: $white;
            margin-top: 62px;
        }
    }
}
</style>
